export const RETRIEVE_FILE_REFUND_DEPOSITS_REQUEST = "RETRIEVE_FILE_REFUND_DEPOSITS_REQUEST"
export const RETRIEVE_FILE_REFUND_DEPOSITS_SUCCESS = "RETRIEVE_FILE_REFUND_DEPOSITS_SUCCESS"
export const RETRIEVE_FILE_REFUND_DEPOSITS_FAILURE = "RETRIEVE_FILE_REFUND_DEPOSITS_FAILURE"
